import envConfig from '@root/env-config.js'
import {isDevTestEnv, isStagingEnv} from '@root/lib/envDetector'

let usingEmulator = envConfig.FIRESTORE_EMULATOR_HOST !== undefined

let siteUrl = ''
let apiUrl = ''

if (isStagingEnv()) {
  siteUrl = `https://${window.location.host}`
  apiUrl = 'https://us-central1-dev-moben.cloudfunctions.net'
} else if (isDevTestEnv()) {
  siteUrl = 'http://localhost:3000'
  apiUrl = 'http://localhost:5001/dev-moben/us-central1'
  if (!usingEmulator) {
    apiUrl = 'https://us-central1-dev-moben.cloudfunctions.net'
  }
} else {
  siteUrl = 'https://moben.com.br'
  apiUrl = 'https://moben.com.br/api'
}

export const SOCIAL_MEDIA_URLS = {
  linkedin: 'https://www.linkedin.com/company/mobenbrasil/',
  instagram: 'https://www.instagram.com/mobenbr/',
  facebook: 'https://www.facebook.com/mobenbr',
}

export const OWNER_DASHBOARD_BLOCK_TITLES = {
  reformas_reparos: 'Reformas e Reparos',
  assistencia_juridica: 'Assistência Jurídica',
  seguro_fianca: 'Seguro Fiança',
  seguro_incendio: 'Seguro Incêndio',
  contrato_vigente: 'Contrato Vigente',
}

export const TENANT_DASHBOARD_BLOCK_TITLES = {
  payments: 'Pagamentos',
  contract: 'Contrato',
  ask: 'Dúvidas',
  additional_documents: 'Documentos Adicionais',
  comprovantes: 'Comprovantes',
}

export const SEND_MAIL_SUCCESS = 'E-Mail enviado com sucesso'
export const SEND_MAIL_FAIL = 'Ops! Falha ao enviar o convite'
export const SEND_MAIL_ALERT_TIME = 3000 // tempo de visibilidade do snackbar
export const SEND_MAIL_ALERT_ZINDEX = 10000
export const CIRCULAR_PROGRESS_ZINDEX = SEND_MAIL_ALERT_ZINDEX + 1000

/* eslint-disable-next-line */
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const CONTRACT_DB_PATH = 'contract_document'
export const BLOG_URL = 'https://blog.moben.com.br/'
export const MOBEN_EMAIL = 'moben@moben.com.br'
export const MOBEN_WHATSAPP = '11913532878'
export const MOBEN_WHATSAPP_SALES = '11988778098'

export const BASE_URL = siteUrl
export const BASE_URL_API = apiUrl

export const MIN_CONTRACT_LENGTH = 3
export const CONTRACT_TYPE_MOBEN = 'by_moben'
export const CONTRACT_TYPE_OWNER = 'by_owner'

export const CREATE_NEW_PROPERTY_PATH = '/cadastro/cadastroimovel'

export const DATASOURCE_ME = 'me'
export const DATASOURCE_OTHER = 'other'
export const DATASOURCE_ADMIN = 'admin'

export const CEP_FORMAT = '########'
export const CPF_FORMAT = '###.###.###-##'
export const CNPJ_FORMAT = '##.###.###/####-##'
export const DATE_BR_FORMAT = '##/##/####'
export const PHONE_FORMAT = '(##) #####-####'

export const STORAGE_BACKLINK = 'back_link'
export const STORAGE_COOKIES = 'cookie_accept'
export const STORAGE_GUIDE1 = 'guide1'
export const STORAGE_UTMS = 'utms'
export const STORAGE_IS_TENANT = 'is_tenant'
export const STORAGE_PROPERTY_ID = 'pid'
export const STORAGE_TENANT_PROPERTY_ID = 'tpid'

export const USER_SOURCE_UNKNOWN = 'unknown'
export const USER_SOURCE_SELF = 'self'
export const USER_SOURCE_INVITE = 'invite'
export const USER_SOURCE_INVITE_FIADOR = 'invite-fiador'
export const USER_SOURCE_CONTRACT = 'contract'
export const USER_SOURCE_PROPOSAL = 'proposal'
export const USER_SOURCE_GUARANTEE = 'guarantee'
export const USER_SOURCE_OWNER = 'owner'
export const USER_SOURCE_BOLETO = 'boleto'

export const LOADER_MODE_SPINNER = 'spinner'
export const LOADER_MODE_TEXT = 'text'

export const monthsMap = {
  0: 'JAN',
  1: 'FEV',
  2: 'MAR',
  3: 'ABR',
  4: 'MAI',
  5: 'JUN',
  6: 'JUL',
  7: 'AGO',
  8: 'SET',
  9: 'OUT',
  10: 'NOV',
  11: 'DEZ',
}
